/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button,
  Flex,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  Space,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { InfoOIcon } from '@tonic-one/react-icons';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  QuarantineSettingModalName,
  QuarantineSettingModalState,
} from './interface';
import { validateEmail } from '../../../utils/common';

enum QTLocation {
  EndUser = 'endUser',
  Admin = 'admin',
}

export function ExChangeOnlineQuarantineSettingModal({
  modal,
  setModal,
}: {
  modal: QuarantineSettingModalState;
  setModal: ({ name, todo }: QuarantineSettingModalState) => void;
}) {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  const [emailString, setEmailString] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [qtLocation, setQtLocation] = useState<QTLocation>(QTLocation.EndUser);

  const onClose = () => {
    setModal({
      name: QuarantineSettingModalName.None,
      todo: null,
    });
  };

  const onChange = (e: any) => {
    const email = (e.target.value as string).trim();
    setEmailString(email);

    if (!validateEmail(email)) {
      setEmailError(true);
      return;
    }
    setEmailError(false);
  };

  const onVerify = async () => {
    setIsVerified(true);
    //await apiVerifyExchangeMailbox([]);
  };

  const onSubmit = async () => {
    //await apiPostExchangeQuarantineSetting();
  };

  useEffect(() => {
    (async () => {
      //await apiGetExchangeQuarantineSetting();
    })();
  }, []);
  return (
    <Modal
      closeOnEsc
      //closeOnOutsideClick
      isClosable
      isOpen={modal.name === QuarantineSettingModalName.OneDrive}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay />
      <ModalContent width={800}>
        <ModalHeader>{t('quarantine.modal.setting.title')}</ModalHeader>
        <ModalBody>
          <Text>{t('quarantine.modal.setting.location.title')}:</Text>
          {/* end user */}
          <Flex direction="column" pl="30px" gap="4px" pt="8px">
            <Radio
              checked={qtLocation === QTLocation.EndUser}
              onClick={() => {
                setQtLocation(QTLocation.EndUser);
                setIsVerified(false);
              }}
            >
              {t('quarantine.modal.setting.location.endUser.name')}
            </Radio>
            <Text pl="24px">
              {t('quarantine.modal.setting.location.endUser.descForMailBox')}
            </Text>
            <Space height="20px" />
            {/* admin */}
            <Radio
              checked={qtLocation === QTLocation.Admin}
              onClick={() => {
                setQtLocation(QTLocation.Admin);
              }}
            >
              {t('quarantine.modal.setting.location.admin.name')}
            </Radio>
            <Text pl="24px">
              {t('quarantine.modal.setting.location.admin.descForMailbox')}
            </Text>
            <Flex align="center" pl="40px" gap="4px">
              <Text className="required">
                {t('quarantine.modal.setting.label.email')}:
              </Text>
              <Flex direction="column" pt="16px">
                <Flex gap="4px">
                  <Input
                    type="email"
                    value={emailString}
                    width="400px"
                    disabled={qtLocation !== QTLocation.Admin}
                    onChange={onChange}
                    error={emailError}
                  />
                  <Button
                    onClick={onVerify}
                    variant="primary"
                    disabled={
                      qtLocation !== QTLocation.Admin ||
                      emailError ||
                      emailString === ''
                    }
                  >
                    {t('common.action.label.verify')}
                  </Button>
                </Flex>
                <Text>{t('quarantine.modal.setting.tip.email')}</Text>
              </Flex>
            </Flex>
          </Flex>

          <Flex gap="8px" align="center" pl="30px" pt="20px">
            <Icon as={InfoOIcon} color={colorStyle.color.info} />
            <Text fontSize="semibold">{t('common.label.note')}:</Text>
            <Text> {t('quarantine.modal.setting.note')}</Text>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            minWidth="20x"
            onClick={onSubmit}
            disabled={qtLocation === QTLocation.Admin && !isVerified}
          >
            {t('common.button.save')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
